import { z } from 'zod';

import { instante } from './common';
import { defineEndpoint } from './endpoint';

export const MetodoPagamentoPadrao = z.enum(['rudpay', 'asaas']);
export type MetodoPagamentoPadrao = z.infer<typeof MetodoPagamentoPadrao>;

/** Linha de `configuracoes` com as chaves de get_configuracoes (`row_to_json`). */
export const Configuracoes = z.object({
  id: z.boolean(),
  percentual_grupo_a: z.number().nullable(),
  percentual_grupo_b: z.number().nullable(),
  percentual_grupo_c: z.number().nullable(),
  percentual_grupo_d: z.number().nullable(),
  percentual_grupo_e: z.number().nullable(),
  metodo_pagamento_padrao: MetodoPagamentoPadrao.nullable(),
  prazo_validade_proposta_dias: z.number().int(),
});

/**
 * Absorve update_prazo_validade_proposta (doc 03, combinado com mod-contratos). O gateway padrão (update_configuracoes)
 * saiu com o RudPay (I34): só há o Asaas. Os índices padrão A–E têm escritor próprio (PUT /api/indices/padrao, doc 04).
 */
export const ConfiguracoesPatch = z.strictObject({
  prazo_validade_proposta_dias: z.number().int().min(1).max(365),
});
export type ConfiguracoesPatch = z.infer<typeof ConfiguracoesPatch>;

export const lerConfiguracoes = defineEndpoint({
  method: 'GET',
  path: '/api/configuracoes',
  output: Configuracoes,
});

export const atualizarConfiguracoes = defineEndpoint({
  method: 'PATCH',
  path: '/api/configuracoes',
  body: ConfiguracoesPatch,
  output: Configuracoes,
});

/** Modo manutenção. `previsao_fim` é opcional; vencida, sai `null` (some da tela, a manutenção continua). */
export const Manutencao = z.strictObject({
  ativa: z.boolean(),
  previsao_fim: instante.nullable(),
});
export type Manutencao = z.output<typeof Manutencao>;

/** Público: a tela de manutenção e o front consultam sem sessão. */
export const lerManutencao = defineEndpoint({
  method: 'GET',
  path: '/api/manutencao',
  output: Manutencao,
});

export const definirManutencao = defineEndpoint({
  method: 'PUT',
  path: '/api/configuracoes/manutencao',
  body: Manutencao,
  output: Manutencao,
});
